// extracted by mini-css-extract-plugin
export var container = "Quote-module--container--151ea";
export var content = "Quote-module--content--e5320";
export var gradient = "Quote-module--gradient--eb8ce";
export var heading = "Quote-module--heading--3847e";
export var outer = "Quote-module--outer--266e0";
export var quote = "Quote-module--quote--1bf41";
export var section = "Quote-module--section--33944";